import React from "react";
import {
    BrowserRouter as Router,
    Redirect,
    Switch,
    Route
} from "react-router-dom";

//Pages
import Login from "./dev/pages/Login";
import Home from "./dev/pages/Home";
import LeadsDisponiveis from "./dev/pages/LeadsDisponiveis";
import MeusLeads from "./dev/pages/MeusLeads";
import MeusClientes from "./dev/pages/MeusClientes";
import Lead from "./dev/pages/Lead";


// Some folks find value in a centralized route config.
// A route config is just data. React is great at mapping
// data into components, and <Route> is a component.

// Our route config is just an array of logical "routes"
// with `path` and `component` props, ordered the same
// way you'd do inside a `<Switch>`.
let isAuthenticated = Boolean(localStorage.getItem("currentUser"));
export const routes = [
    {
        name: "Relatórios",
        path: "/relatorios",
        component: Home,
        isAuthenticated : true

    },
    {
        name: "Lead",
        path: "/lead/:id",
        component: Lead,
        isAuthenticated : true

    },
    {
        name: "Leads Disponíveis",
        path: "/leads-disponiveis",
        component: LeadsDisponiveis,
        isAuthenticated : true
    },
    {
        name: "Meus Leads",
        path: "/meus-leads",
        component: MeusLeads,
        isAuthenticated : true
    },
    {
        name: "Meus Clientes",
        path: "/meus-clientes",
        component: MeusClientes,
        isAuthenticated : true
    },

    {
        name: "Login",
        path: "/",
        component: Login
    },

];

export default function RouteConfigExample() {
    return (
        <Router>
            <Switch>
                {/* <Route path="/lead/:id" render={props => <Lead {...props} />} /> */}

                {routes.map((route, i) => (
                    (route.hasOwnProperty("isAuthenticated") && route.isAuthenticated) ? <RouteWithSubRoutesPrivate key={i} {...route} /> : <RouteWithSubRoutes key={i} {...route} />

                ))}



            </Switch>
        </Router>
    );
}

// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={props => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}
function RouteWithSubRoutesPrivate(route) {
    return (
        <Route
            path={route.path}
            render={props => route.isAuthenticated && isAuthenticated ? (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            ) : (
                    <Redirect
                        to={{
                            pathname: "/?url_return=" + window.location.href
                        }}
                    />
                )
            }
        />
    );
}
